import { imageURL } from "../constants";

export default {
    name: "acceso",
    components: {},
    data() {
        return {
            imageId: "",
            url: ""
        };
    },

    computed: {},

    async mounted() {
        this.imageId = this.$route.params.imageId;
        this.url = imageURL(this.imageId);
        window.console.log("IMAGE MOUNTED", this.imageId);
    },

    methods: {}
};
